import { httpRequest } from "../../../utils/HttpRequest";
import {
    IExportField,
    IKey,
    IMdCmFields,
    IPage,
    ISearchPageField
} from "../../../types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";


export interface IMdCustomerFields extends IMdCmFields {
    linkCode?: string;
    code?: string;
    name?: string;
    categoryCode?: string;
    categoryName?: string;
    level?: number;
    contact?: string;
    phone?: string;
    tel?: string;
    fax?: string;
    email?: string;
    website?: string;
    address?: string;
    invoiceHeader?: string;
    businessLicenseNo?: string;
    bank?: string;
    bankAccount?: string;
    postAddress?: string;
    corporation?: string;
    businessScope?: string;
    status?: number;
    note?: string;
}

export type IMdCustomerDetail = IKey & IMdCustomerFields;
export type IMdCustomerSearch = IMdCustomerFields & ISearchPageField;
export type IMdCustomerExport = IMdCustomerFields & IExportField;

class CustomerService {
    async insert(insertVo: IMdCustomerFields) {
        const apiUrl = "/customer/insert";
        return await httpRequest.post<IMdCustomerDetail>(apiUrl, insertVo);
    }

    async update(updateVo: IMdCustomerFields) {
        const apiUrl = "/customer/update";
        return await httpRequest.post<IMdCustomerDetail>(apiUrl, updateVo);
    }

    async disable(oneVo: IMdCustomerFields) {
        const apiUrl = "/customer/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo);
    }

    async find(searchVo: IMdCustomerFields, config: object = {}) {
        const apiUrl = "/customer/find";
        return await httpRequest.post<IMdCustomerDetail[]>(apiUrl, searchVo, config);
    }

    async page(searchVo: IMdCustomerSearch) {
        const apiUrl = "/customer/page";
        return await httpRequest.post<IPage<IMdCustomerDetail>>(apiUrl, searchVo);
    }

    async one(oneVo: IMdCustomerFields) {
        const apiUrl = "/customer/one";
        return await httpRequest.post<IMdCustomerDetail>(apiUrl, oneVo);
    }

    async sync(syncVo: IMdCustomerFields) {
        const appPageUrl = "/customer/sync";
        syncVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, syncVo, { timeout: LONG_REQUEST_TIMEOUT});
    }

    async syncPage(searchVo: IMdCustomerSearch) {
        const appPageUrl = "/customer/syncPage";
        searchVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, searchVo);
    }

    async syncOne(oneVo: IMdCustomerFields) {
        const appPageUrl = "/customer/syncPage";

        return await httpRequest.post<boolean>(appPageUrl, oneVo);
    }
}

export const customerService = new CustomerService();
